// Small candidate lookups used across components.
import type { CandidateConfig, RaceConfig } from '../types/config.ts';

export function candidateById(race: RaceConfig, id: string | null): CandidateConfig | undefined {
  if (!id) return undefined;
  return race.candidates.find((c) => c.id === id);
}

export function candidateName(race: RaceConfig, id: string | null): string {
  const c = candidateById(race, id);
  return c ? (c.shortName ?? c.name) : (id ?? '—');
}

export function candidateFullName(race: RaceConfig, id: string | null): string {
  const c = candidateById(race, id);
  return c ? c.name : (id ?? '—');
}
